import React, { useEffect } from "react"
import { navigate } from "gatsby"
import Layout from "../components/Layout"
import AIAuditQuestionnaire from "../components/AIAuditQuestionnaire"

const AIAuditPage = ({ location }) => {
  const userInfo = location?.state?.userInfo

  useEffect(() => {
    if (!userInfo) navigate("/")
  }, [userInfo])

  if (!userInfo) return null

  return (
    <Layout
      pageTitle="Visiomate — AI Audit"
      descrip="Answer 15 quick questions and receive a personalised AI Audit Report for your organisation — free from Visiomate."
    >
      <AIAuditQuestionnaire userInfo={userInfo} />
    </Layout>
  )
}

export default AIAuditPage
